<template>
	<div class="free-container">
		<div class="free-rooms total">
			Total: {{total}}
		</div>
		<div
			class="free-rooms"
			v-for="(day, indexDay) in model.ratesPerDates"
			:key="indexDay"
		>
			<div
				class="free-rooms-type"
				v-for="(room, indexRoom) in day.roomTypes"
				:key="indexRoom"
			>
				<span>{{room.name}}</span>
				<span>{{room.total}}</span>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'free-rooms-day',
	props: {
		model: {
			default: () => {},
			type: Object,
		},
		total: {
			default: 0,
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.free-container {
	display: flex;

	.free-rooms {
		background-color: map-get($colors, header-dark);
		border-right: 1px solid map-get($colors, border-radio);
		color: white;
		min-width: $widthItemDay;
		padding: 7px 5px;
		width: $widthItemDay;
		
	
		.free-rooms-type {
			align-items: center;
			border-top: 1px solid map-get($colors, border-radio);
			display: flex;
			justify-content: space-between;
		}
		.free-rooms-type:first-child {
			border-top: none;
		}
	}

	.total {
		align-items: center;
		display: flex;
		font-weight: map-get($weights, w-six);
		height: 50px;
		justify-content: center;
		left: 0;
		position: sticky;
	}
}
</style>




// WEBPACK FOOTER //
// FreeRoomsDay.vue?3b0e3b1b